import React from "react";

const About = () => (
	<section className="py-20 px-4 mx-auto flex flex-col md:flex-row" id="about">
		<div className="basis-1/2 md:px-4 text-justify mb-5 md:mb-0">
			<h3 className="text-3xl font-semibold mb-4">About Us</h3>
			<p className="text-slate-700 mb-3 font-semibold">
				Diamond Heirs Limited is a dynamic and forward-thinking Information
				Technology (IT) infrastructure company, dedicated to delivering
				innovative, reliable, and cost-effective solutions tailored to meet the
				evolving needs of modern businesses, institutions, and public sector
				organizations. Established with a vision to transform the technological
				landscape of Nigeria and beyond, Diamond Heirs Limited has positioned
				itself as a trusted partner in the delivery of comprehensive ICT,
				infrastructure, and specialized services.
			</p>

			<p className="font-semibold">
				At Diamond Heirs Limited, we believe that technology is the foundation
				for progress, productivity, and growth in every sector. We are committed
				to offering holistic solutions that bridge the gap between business
				goals and technology, enabling our clients to achieve operational
				efficiency, enhanced customer experiences, and sustainable growth.
			</p>
		</div>

		<div className="basis-1/4 md:px-4 text-justify mb-5 md:mb-0">
			<h3 className="text-3xl font-semibold mb-4">Our Vision</h3>
			<p className="text-slate-700 font-semibold">
				To be a leading provider of comprehensive ICT and infrastructure
				solutions in Africa, renowned for innovation, quality, and
				customer-centric service delivery.
			</p>
		</div>

		<div className="basis-1/4 md:px-4 text-justify mb-5 md:mb-0">
			<h3 className="text-3xl font-semibold mb-4">Our Mission</h3>
			<p className="text-slate-700 font-semibold">
				To deliver top-notch, technology-driven, and value-oriented solutions
				that empower businesses and institutions to succeed in an increasingly
				digital and competitive world.
			</p>
		</div>
	</section>
);

export default About;
